'use client'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import React, { useEffect, useState } from 'react'
import { CustomInstallPopup } from '../popup-mobile/popup-mobile';

let nativePopup: BeforeInstallPWAEvent | null = null

interface BeforeInstallPWAEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

export default function InstallPWA() {
  const [showPopup, setShowPopup] = useState(false)
  const { merchantSummary } = useMerchant()
  const [closePopUp, setClosePopUp] = useState(false)

  const getDevice = () => {
    const ua = navigator.userAgent
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return 'tablet'
    }
    if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
      return 'mobile'
    }
    return 'desktop'
  }

  useEffect(() => {
    const handleInstallPWA = (e: Event) => {
      e.preventDefault()
      nativePopup = e as BeforeInstallPWAEvent
      if (getDevice() !== 'desktop') {
        setTimeout(() => setShowPopup(true), 5000)
      }
    }

    window.addEventListener('beforeinstallprompt', handleInstallPWA)

    return () => {
      window.removeEventListener('beforeinstallprompt', handleInstallPWA)
    }
  }, [])

  const handleInstallClick = () => {
    if (nativePopup) {
      nativePopup.prompt()
      nativePopup.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          setShowPopup(false)
        } else {
          setShowPopup(false)
        }
      })
    }
  }

  const handleClosePopup = () => {
    setClosePopUp(true)
    setTimeout(() => {
      setClosePopUp(false)
      setShowPopup(false)
    }, 300);
  }

  if (!showPopup) return null

  return (
    <CustomInstallPopup
      isOpen={showPopup}
      logoUrl={merchantSummary?.logoUrl || ""}
      merchantName={merchantSummary?.name || ""}
      mainText={`Deseja adicionar ${merchantSummary?.name} à tela inicial?`}
      subText={
        <>
          Acesse todo o conteúdo do site pelo ícone do cardápio na tela de seu dispositivo.
        </>
      }
      onClose={handleClosePopup}
      onInstall={handleInstallClick}
      mainTextId="installPwaText"
    />
  )
}
